import {NgModule} from '@angular/core';

import {CollapseModule} from 'ngx-bootstrap/collapse';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {AgGridModule} from 'ag-grid-angular';
import {SendungsereignisseComponent} from './sendungsereignisse.component';
import { SendungereignisInfoCellComponent } from './sendungereignis-info-cell/sendungereignis-info-cell.component';
import {CommonModule} from '@angular/common';


@NgModule({
  declarations: [SendungsereignisseComponent, SendungereignisInfoCellComponent],
    imports: [
        CollapseModule,
        AgGridModule,
        FontAwesomeModule,
        CommonModule
    ],
  exports: [SendungsereignisseComponent],
  entryComponents: [SendungereignisInfoCellComponent]
})
export class SendungsereignisseModule {
}
